
import { Component, Vue } from 'vue-property-decorator';

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import Form22StyleOfProceeding from "@/components/process/Form22/components/Form22StyleOfProceeding.vue";
import { form22StatusInfoType } from '@/types/Information/Form22';

@Component({
    components:{
        Form22ProcessHeader,        
        Form22StyleOfProceeding
    }
})
export default class FillForm22 extends Vue {

    stepsCompleted = {} as form22StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
